module.exports = __webpack_public_path__ + "static/media/Explore galaxy.0700c1f2.png";